var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2459_9851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2459_9851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.75C6.7125 12.75 6.89062 12.6781 7.03438 12.5344C7.17812 12.3906 7.25 12.2125 7.25 12C7.25 11.7875 7.17812 11.6094 7.03438 11.4656C6.89062 11.3219 6.7125 11.25 6.5 11.25C6.2875 11.25 6.10938 11.3219 5.96562 11.4656C5.82187 11.6094 5.75 11.7875 5.75 12C5.75 12.2125 5.82187 12.3906 5.96562 12.5344C6.10938 12.6781 6.2875 12.75 6.5 12.75ZM6.5 9.75C6.7125 9.75 6.89062 9.67813 7.03438 9.53438C7.17812 9.39063 7.25 9.2125 7.25 9C7.25 8.7875 7.17812 8.60938 7.03438 8.46563C6.89062 8.32188 6.7125 8.25 6.5 8.25C6.2875 8.25 6.10938 8.32188 5.96562 8.46563C5.82187 8.60938 5.75 8.7875 5.75 9C5.75 9.2125 5.82187 9.39063 5.96562 9.53438C6.10938 9.67813 6.2875 9.75 6.5 9.75ZM6.5 6.75C6.7125 6.75 6.89062 6.67812 7.03438 6.53438C7.17812 6.39062 7.25 6.2125 7.25 6C7.25 5.7875 7.17812 5.60938 7.03438 5.46562C6.89062 5.32187 6.7125 5.25 6.5 5.25C6.2875 5.25 6.10938 5.32187 5.96562 5.46562C5.82187 5.60938 5.75 5.7875 5.75 6C5.75 6.2125 5.82187 6.39062 5.96562 6.53438C6.10938 6.67812 6.2875 6.75 6.5 6.75ZM8.75 12.75H13.25V11.25H8.75V12.75ZM8.75 9.75H13.25V8.25H8.75V9.75ZM8.75 6.75H13.25V5.25H8.75V6.75ZM4.25 15.75C3.8375 15.75 3.48438 15.6031 3.19063 15.3094C2.89688 15.0156 2.75 14.6625 2.75 14.25V3.75C2.75 3.3375 2.89688 2.98438 3.19063 2.69063C3.48438 2.39688 3.8375 2.25 4.25 2.25H14.75C15.1625 2.25 15.5156 2.39688 15.8094 2.69063C16.1031 2.98438 16.25 3.3375 16.25 3.75V14.25C16.25 14.6625 16.1031 15.0156 15.8094 15.3094C15.5156 15.6031 15.1625 15.75 14.75 15.75H4.25Z",
    fill: "#79818A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAlt);
export default __webpack_public_path__ + "static/media/list_alt.c63dfedefe18ebc5c514ce2a207e99b3.svg";
export { ForwardRef as ReactComponent };